import React, { FC } from 'react';

import NumberBox from './NumberBox';

interface Props {
  image: string;
  text: string;
  number: number;
  textWidth: string;
}

const Step: FC<Props> = ({ image, text, number, textWidth }) => {
  return (
    <li className="flex md:flex-col md:justify-center items-center w-full md:w-1/3 mb-40 md:mb-0">
      <div className="flex md:h-56 order-2 md:order-1 mr-24 md:mr-0">
        <img
          className="h-auto w-48 m-auto md:h-full md:w-auto"
          src={image}
          alt={text}
        />
      </div>
      <div className="order-1 md:order-2 mr-24 md:mr-0 md:mt-24 md:mb-12">
        <NumberBox number={number} />
      </div>
      <h3 className={`font-body4 md:text-center order-3 md:${textWidth}`}>
        {text}
      </h3>
    </li>
  );
};

export default Step;
